import React from "react";
import { useRef } from "react";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
const CustomScroll = ({ children }) => {
    const modalBodyRef = useRef(null);
    const updateScrollClasses = (viewport) => {
        if (!viewport || !modalBodyRef.current)
            return;
        const el = modalBodyRef.current;
        const { scrollTop, clientHeight, scrollHeight } = viewport;
        el.classList.toggle("scroll-top", scrollTop === 0);
        el.classList.toggle("scroll-bottom", scrollTop + clientHeight >= scrollHeight);
    };
    return (React.createElement("div", { className: "modal-body scroll-top", ref: modalBodyRef },
        React.createElement(OverlayScrollbarsComponent, { options: {
                scrollbars: {
                    visibility: "auto",
                    autoHide: "leave",
                }
            }, events: {
                initialized: (instance) => {
                    const { viewport } = instance.elements();
                    setTimeout(() => updateScrollClasses(viewport), 100);
                },
                scroll: (instance, event) => {
                    const { viewport } = instance.elements();
                    updateScrollClasses(viewport);
                }
            }, defer: true }, children)));
};
export default CustomScroll;
